import dayjs from './dayjs';
export const INVOICE_STATUS_OPTIONS = {
  draft: 'Draft',
  open: 'Open',
  paid: 'Paid',
  void: 'Void',
};

export const CATEGORY_OPTIONS = {
  maker: 'Maker',
  logistics: 'Logistics',
  design: 'Design',
  materials: 'Materials',
};

export const PAYMENT_METHOD_OPTIONS = {
  '': '',
  stripe: 'Stripe',
  bunq: 'Bunq',
};

const serialiseFileData = ({ data, field }) => {
  const fileData =
    data[field] && data[field].length === 1
      ? data[field][0]
      : { url: null, name: null };

  const serialised = {};
  serialised[`${field}URI`] = fileData.url;
  serialised[`${field}Name`] = fileData.name;
  return serialised;
};

const deSerialiseFileData = ({ data, field }) => {
  const deserialised = {};
  const url = data[`${field}URI`];
  const name = data[`${field}Name`];

  // Only create file entry if there's actual file data
  deserialised[field] = url || name ? [{ url, name }] : [];
  return deserialised;
};

export const serialiseInvoiceData = (data) => {
  const formatNum = (num = 0) => Math.round(num || 0);

  if (data.dueDate) {
    data.daysUntilDue = dayjs(data.dueDate).diff(
      dayjs(data.invoiceDate),
      'day'
    );
  }

  data = {
    ...data,
    totalAmount: formatNum(data.totalAmount),
    totalInAmount: formatNum(data.totalInAmount),
    vatAmount: formatNum(data.vatAmount),
    paidAt: timeStampFromDate(data.paidAt),
    ...serialiseFileData({ data, field: 'invoicePDF' }),
    ...serialiseFileData({ data, field: 'proformaPDF' }),
  };

  // formulate adds 1 empty item to group by default -> filter empty items
  data.orders = (data.orders || [])
    .filter((o) => o.id && o.amount)
    .map((o) => ({
      id: o.id,
      orderSupplierInvoice: { amount: formatNum(o.amount) },
    }));

  data.items = (data.items || []).map((i) => ({
    ...i,
    amount: formatNum(i.amount),
  }));

  return data;
};

export const deSerialiseInvoiceData = (data) => {
  const formatNum = (num = 0) => num || 0;

  if (data.daysUntilDue) {
    data.dueDate = dayjs(data.invoiceDate)
      .add(data.daysUntilDue, 'day')
      .format('YYYY-MM-DD');
  }
  data = {
    ...data,
    totalAmount: formatNum(data.totalAmount),
    totalInAmount: formatNum(data.totalInAmount),
    vatAmount: formatNum(data.vatAmount),
    paidAt: dateFromTimestamp(data.paidAt),
    ...deSerialiseFileData({ data, field: 'invoicePDF' }),
    ...deSerialiseFileData({ data, field: 'proformaPDF' }),
  };

  data.orders = (data.orders || []).map((o) => ({
    id: o.id,
    amount: formatNum(o.orderSupplierInvoice.amount),
  }));

  data.items = (data.items || []).map((i) => ({
    ...i,
    amount: formatNum(i.amount),
  }));

  return data;
};

export const dateFromTimestamp = (stamp) =>
  stamp && dayjs(stamp).format('YYYY-MM-DD');

export const timeStampFromDate = (date) => date && `${date}T00:00:00.000Z`; // hardcoding to be at midnight UTC

export const diffToDate = (now, dueDate) => {
  if (!dueDate) return null;

  const invoiceDate = dayjs(dueDate);
  const diff = now.diff(invoiceDate, 'day');

  if (diff === 0 && now.diff(invoiceDate, 'second') < 0) {
    return -1;
  }
  if (diff === 0 && now.diff(invoiceDate, 'second') > 0) {
    return 1;
  }

  return diff === 0 ? diff + 1 : diff;
};

export const isOverdue = (invoice) => diffToDate(dayjs(), invoice.dueDate) > 0;
